import {
    GetList,
    PostStaff,
    DeleteStaff,
    GetStaff,
    PutStaff,
    ChangeStaffStatus,
} from '@src/services/staff'
import { getSavedState } from '@src/utils/localStorage'

export const state = {
    listStaff: [],
    staffFormState: {
        firstName: '',
        lastName: '',
        gender: '',
        birthday: '',
        document: '',
        postalCode: '',
        address: '',
        addressNumber: '',
        addressComplement: '',
        neighborhood: '',
        country: '',
        state: '',
        city: '',
        email: '',
        telephone: '',
        status: true,
        locationPublicId: '',
        publicId: '',
    },
    staffState: {
        locationId: '',
        qField: '',
        qStatus: true,
        qCurrentPage: 1,
        qPageSize: 20,
        Status: false,
    },
}

export const getters = {
    totalList(state) {
        return state.listStaff.data ? state.listStaff.data.totalItemCount : 0
    },
}

export const mutations = {
    FETCH_LOCALS(state, locals) {
        state.listStaff = locals
    },
    SET_STATE(state, payload) {
        if (state.listStaff.data) {
            state.listStaff.data.items.find(({ publicId }) => {
                return publicId === payload.publicId
            }).status = payload.status
        }
    },
    SET_STATE_FORM(state, payload) {
        state.staffFormState = payload
    },
    UPDATE_PLAN(state, payload) {
        state.staffFormState = payload
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.listStaff.data.items.push(team)
        })
    },
}

export const actions = {
    // retorna a lista de piscinas
    async fetchList({ commit, state }, parameters = {}) {
        // se a lista de staff estiver vazia, ela é preenchida com opções
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetList(locationPublicId, parameters)

        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
        }
    },
    async getStaff({ commit }, parameters) {
        const resp = await GetStaff(parameters)
        if (resp && resp.status === 200) {
            return resp.data.data
        }
    },
    async saveNewStaff({ commit }, parameters) {
        const resp = await PostStaff(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
            return true
        }
        return false
    },
    async editStaff({ commit }, parameters) {
        const resp = await PutStaff(parameters)
        if (resp && resp.status === 200) {
            commit('FETCH_LOCALS', resp.data)
            return true
        }
        return false
    },
    async delete({ commit, dispatch }, data) {
        const resp = await DeleteStaff(data)

        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async changeActiveStatus({ commit, dispatch }, data) {
        const resp = await ChangeStaffStatus(data)
        if (resp.status === 200) {
            commit('SET_STATE', data)
            dispatch('fetchList')
            return true
        }
        return false
    },
    async nextPage({ commit }, currentPage) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetList(locationPublicId, currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
}
